import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { merge } from "lodash";

export default function PlantSelector({ config, sx }: any) {
  const {
    availablePlants,
    isOptionEqualToValue,
    onChange,
    selectedPlant,
    usePlantCode = false,
  } = config;

  const getOptionLabel = (option: any) => {
    if (option === "All Plants") return "All Plants";

    return usePlantCode ? option.plant_code : option.plant_name;
  };

  const mergedSx = merge({
    mr: 1,
    minWidth: '80px'
  }, sx);

  return (
    <Autocomplete
      sx={mergedSx}
      style={{
        backgroundColor: "#293368",
        maxWidth: "250px",
        width: "200px",
      }}
      fullWidth
      options={availablePlants}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      value={selectedPlant}
      onChange={onChange}
      size="small"
      renderInput={(params: any) => (
        <TextField
          {...params}
          style={{ border: "none" }}
          placeholder="Select Plant"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {!availablePlants?.length && (
                  <CircularProgress color="inherit" size={20} />
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      disableClearable
    />
  );
}
